import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { EmploymentConfig } from 'app/employment/employment.config';
import * as ACTIONS_INTERFACE from '../../../actions';
import { EmploymentService } from 'app/employment/employment.service';

declare var $: any;

@Component({
  selector: 'additional-education-reconfirm',
  templateUrl: './additional-education-reconfirm.component.html',
  styleUrls: ['./additional-education-reconfirm.component.css']
})
export class AdditionalEducationReconfirmComponent implements OnInit {
  static STAGE_ID: string;
  static STEP_ID: string = 'additional-education-step-v1';
  static STEP_INDEX: number = 0;
  public SUB_STEP_ID: string;
  public SUB_STEP_INDEX: number;
  PARENT_STAGE_STEP_CONFIG: Object;
  
  isAdditionalEducationReconfirm: boolean = false;
  isReconfirmSelected: boolean = false;
  currentStatus: string = 'VISITED';
  payLoad: Object;
  startTime: any;
  
  @Input('group')
    public additionalEducationSubForm: FormGroup;
  @Input() configOptions: any;
  @Input() row: any;
    
  @Output() onSaveExit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAdditionalEducationReconfirm = new EventEmitter<any>();
  @Output() onAdditionalEducationReconfirmSwipe = new EventEmitter<any>();
  
  constructor(private _employmentService: EmploymentService,
              private _store: Store<ACTIONS_INTERFACE.AppState>) {
    this.startTime = new Date().getTime();
  }
  
  ngOnInit() {
    this.processConfig();
    
    // If _employmentService.getAdditionalEducationServerData length is greater than 0 and current row is available in getAdditionalEducationServerData, then set with jQuery reconfirmYes to true
    if (this._employmentService.getAdditionalEducationServerData().length > 0 && this._employmentService.getAdditionalEducationServerData()[this.row]) {
      this.isReconfirmSelected = true;
      this.isAdditionalEducationReconfirm = true;
    } 
  }
    
  shouldEnableReconfirm(index) {
    $('#reconfirmYes_' + index).prop('checked', true).trigger('change');
  }
  
  private processConfig(): void {
    this.PARENT_STAGE_STEP_CONFIG = this.configOptions['PARENT_CONFIG'];
    this.SUB_STEP_ID = EmploymentConfig.additionalEducationSubStepIndexMapping['knockout']['subStep'];
    this.SUB_STEP_INDEX = EmploymentConfig.additionalEducationSubStepIndexMapping['knockout']['subStepIndex'];

    this.setState();
  }
  
  private setState(): void {
    this.payLoad = {
      name: this.PARENT_STAGE_STEP_CONFIG['STAGE_ID'],
      step: AdditionalEducationReconfirmComponent.STEP_ID,
      stepIndex: AdditionalEducationReconfirmComponent.STEP_INDEX,
      subStep: this.SUB_STEP_ID,
      subStepIndex: this.SUB_STEP_INDEX,
      iteration: null,
      status: this.currentStatus,
      dbRecordPresent: this.PARENT_STAGE_STEP_CONFIG['IS_DB_RECORD_PRESENT']
    };

    this._store.dispatch({ type: this.currentStatus, payload: this.payLoad });
  }
  
  setRadio(inputValue) {
    this.isReconfirmSelected = true;
    
    if (inputValue === 'Yes') {
      this.isAdditionalEducationReconfirm = true;
    } else {
      this.isAdditionalEducationReconfirm = false;
    }
  }
  
  onNextClick() {
    $('#empWaitModal').modal('show');
    
    let obj: Object = {};
    
    if (this.currentStatus === 'VISITED') {
      this.currentStatus = 'COMPLETED'
    }
    
    this.setState();
    
    obj['COMPONENT_STATE'] = this.payLoad;
    obj['startTime'] = this.startTime;

    let indexDetail: Object = {};
    indexDetail['row'] = this.row;
    obj['indexDetail'] = indexDetail;
    obj['isAdditionalEducationReconfirm'] = this.isAdditionalEducationReconfirm;

    this.onAdditionalEducationReconfirm.emit(obj);
  }
  
  getPrevSwipe(obj) {
    let indexDetail: Object = {};
    indexDetail['row'] = this.row;
    obj['indexDetail'] = indexDetail;
    
    this.onAdditionalEducationReconfirmSwipe.emit(obj);
  }

  saveExit() {
    this.onSaveExit.emit();
  }
}
